/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Stages/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import Stage from './Stage/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Stages({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Content/Tasks/Content/ActionsAction/Content/Content/Stages"
  
}) {
let taskBoardStagesValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'board.stages',
})
  return (<React.Fragment
>
<div
  data-testid="Stages.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(taskBoardStagesValueData) && taskBoardStagesValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="stage"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Stage(${item?.id ?? item?._id ?? index})`}
      >
<Stage
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Stage(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }